import {gql} from '@apollo/client';
import {getDomainGraphqlError, useMutation$} from "../../graphqlsupport";
import {useCallback} from "react";
import {showToast} from "common";

export const MARK_PROVIDER_EVENTS_AS_READ = gql`
    mutation ($providerEventGuids: [UUID!] ){
        markProviderEventsAsUnread(providerEventGuids: $providerEventGuids)
    }
`;

type MarkProviderEventsAsUnreadInput = {
    providerEventGuids: string[],
}

export const useMarkProviderEventsAsUnread = (
    successCallback: () => void,
) => {
    const {
        isRunning$,
        execute,
    } = useMutation$<MarkProviderEventsAsUnreadInput, void>(MARK_PROVIDER_EVENTS_AS_READ);

    const markProviderEventsAsUnread = useCallback(async (providerEventGuids: string[]) => {
        try {
            const {data: result,} = await execute({
                variables: {
                    providerEventGuids: providerEventGuids,
                }
            });
            if (result) {
                successCallback();
                showToast.success(`Notification mark as unread`);
            }
        } catch (e: any) {
            showToast.error(getDomainGraphqlError(e) ?? `Unable to mark notification as unread: ${e.message || e[0].message}`);
        }
    }, [execute, successCallback]);


    return {
        isRunning$,
        execute: markProviderEventsAsUnread,
    };
};
